import * as actionTypes from './actionTypes'

export const setLoading = (data) => {
    return {
        type: actionTypes.SET_LOADING,
        data
    }
}

export const resetStore = (data) => {
    return {
        type: actionTypes.USER_LOGOUT,
        data
    }
}

export const loadBrandAuthConfig = () => {
    return {
        type: actionTypes.LOAD_BRAND_AUTH_CONFIG
    }
}

export const loadQuizDetails = (data) => {
    return {
        type: actionTypes.LOAD_QUIZ_DETAILS,
        data
    }
}

export const loadQuizTypeDetails = (data) => {
    return {
        type: actionTypes.LOAD_QUIZ_TYPE_DETAILS,
        data
    }
}



/** WEBPACK FOOTER **
 ** ./src/store/actions/commonAction.js
 **/